import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { useError } from '../../hooks/useError';
import ErrorMessage from '../ErrorMessage';
import { isPick7iOSWebView } from '../../utils/authUtils';

export const Layout = ({ loggedIn, userName, children }) => {
    const { error } = useError();

    useEffect(() => {
        if (error) {
            // Scroll the user to the error at the top of the page.
            window.scrollTo(0, 0);
        }
    });

    return (
        <Styled.LayoutWrapper>
            {loggedIn && (
                <Styled.WelcomeMessage>
                    Welcome, <Styled.Name>{userName}</Styled.Name>
                </Styled.WelcomeMessage>
            )}
            <ErrorMessage message={error} />
            {children}
            <Styled.Footer>
                {!isPick7iOSWebView() && (
                    <div>
                        By using this site, you agree we can set and use
                        cookies. For more details of these cookies and how to
                        manage them, see{' '}
                        <Styled.LinkButton
                            onClick={() => {
                                if (window.Android?.showCookieManagement) {
                                    window.Android.showCookieManagement();
                                    return;
                                }

                                if (window.OneTrust) {
                                    window.OneTrust.ToggleInfoDisplay();
                                }
                            }}
                        >
                            cookie management
                        </Styled.LinkButton>
                        .
                    </div>
                )}
                {isPick7iOSWebView() && (
                    <div>
                        By using this site, you agree we can set and use
                        cookies.
                    </div>
                )}
                <Styled.Copyright>
                    © Copyright ITV Consumer Limited {new Date().getFullYear()}.
                    The ITV Racing 7 and ITV Racing logos are trade marks of ITV
                    Rights Limited.
                </Styled.Copyright>
            </Styled.Footer>
        </Styled.LayoutWrapper>
    );
};

Layout.defaultProps = {
    userName: null,
    children: null
};

Layout.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    userName: PropTypes.string,
    children: PropTypes.node
};

export default Layout;
